<template>
  <v-container fluid>
    <v-form class="pa-0" ref="form" v-model="validForm" lazy-validation>

      <v-col>
        <v-row>
          <h2 v-if="!$route.params.id" :class="$vuetify.theme.isDark ? 'white--text' : ''">
            Crear Corrida
          </h2>

          <h2 v-else :class="$vuetify.theme.isDark ? 'white--text' : ''">
            Editar Corrida
          </h2>

          <v-spacer></v-spacer>

          <v-btn
            :disabled="!validForm"
            :loading="previewLoading || saving"
            class="mx-1"
            elevation="0"
            color="primary"
            rounded
            @click="validateForm">
            Guardar
          </v-btn>

          <v-btn
            class="mx-1"
            elevation="0"
            color="error"
            rounded
            v-if="$route.params.id"
            @click="destroyDialog = true">
            Eliminar
          </v-btn>
        </v-row>
      </v-col>

      <v-row>
        <v-col cols="12" md="6">
          <v-card>
            <v-card-title class="pb-2">
              <h4 :class="$vuetify.theme.isDark ? 'white--text' : ''">
                <v-icon :color="$vuetify.theme.isDark ? 'white' : 'secondary'">mdi-clipboard-text</v-icon>
                Descripción
              </h4>
            </v-card-title>

            <v-card-text>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field :rules="emptyRule" hide-details dense outlined v-model="payload.name" label="Nombre">
                  </v-text-field>
                </v-col>

                <v-col cols="12" md="6" class="px-6 py-0">
                  <v-row align="center" justify="center">
                    <h4 class="mb-0 pr-3" :class="$vuetify.theme.isDark ? 'white--text' : ''">Activo:</h4>
                    <v-switch :color="$vuetify.theme.isDark ? 'primary' : 'secondary'" v-model="payload.enabled">
                    </v-switch>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="12" md="6">
          <v-card>
            <v-card-title class="pb-2">
              <v-row justify="space-between" align="center">
                <v-col cols="8">
                  <h4 class="mb-0" :class="$vuetify.theme.isDark ? 'white--text' : ''">
                    <v-icon :color="$vuetify.theme.isDark ? 'white' : 'secondary'">mdi-clipboard-text</v-icon>
                    Items ({{ payload.items.length }})
                  </h4>
                </v-col>
                <v-btn @click="addChip" class="mx-4" fab small elevation="0" rounded color="primary">
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </v-row>
            </v-card-title>

            <v-card-text>
              <hr class="my-0">
              <v-col cols="12">
                <v-row justify="start" :key="index" v-for="(row, index) in sortedItems">
                  <v-col class="pb-0" md="6" lg="3" cols="6">
                    <v-text-field :rules="emptyRule" v-model="row.value" label="Talla"></v-text-field>
                  </v-col>

                  <v-col class="pb-0" md="6" lg="3" cols="6">
                    <v-text-field label="Orden" :rules="emptyRule" v-model="row.order"></v-text-field>
                  </v-col>

                  <v-col>
                    <template v-if="payload.items.length > 1">
                      <v-btn @click="removeChip(index)" small icon>
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                    </template>
                  </v-col>
                </v-row>
              </v-col>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Diálogo de confirmación de impacto -->
      <v-dialog v-model="confirmDialog" max-width="480" persistent>
        <v-card>
          <v-card-title class="headline">Confirmar cambios</v-card-title>

          <v-card-text v-if="summary">
            <p class="mb-4">La corrida será aplicada a
              <strong>{{ summary.productos_afectados }}</strong> productos.
            </p>

            <v-simple-table dense>
              <tbody>
                <tr>
                  <td>Se crearán</td>
                  <td class="text-right"><strong>{{ summary.variantes_creadas }}</strong> variantes</td>
                </tr>
                <tr>
                  <td>Se actualizarán</td>
                  <td class="text-right"><strong>{{ summary.variantes_actualizadas }}</strong> variantes</td>
                </tr>
                <tr>
                  <td>Se eliminarán</td>
                  <td class="text-right"><strong>{{ summary.variantes_eliminadas }}</strong> variantes</td>
                </tr>
                <tr v-if="summary.variantes_con_stock">
                  <td>Con inventario (no se eliminan)</td>
                  <td class="text-right"><strong>{{ summary.variantes_con_stock }}</strong></td>
                </tr>
                <tr v-if="summary.inconsistencias">
                  <td class="warning--text">Se encontraron</td>
                  <td class="text-right warning--text">
                    <strong>{{ summary.inconsistencias }}</strong> inconsistencias
                  </td>
                </tr>
              </tbody>
            </v-simple-table>

            <p class="mt-4 mb-0">¿Desea continuar?</p>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="primary" text :disabled="saving" @click="confirmDialog = false">
              Cancelar
            </v-btn>
            <v-btn elevation="0" class="pa-4" rounded color="primary" :loading="saving" @click="update">
              Continuar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Diálogo de eliminación -->
      <v-dialog v-model="destroyDialog" max-width="400">
        <v-card>
          <v-card-title class="headline">¿Estas seguro?</v-card-title>
          <v-card-text>Una vez elimines el registro, no podrás recuperarlo.</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn rounded color="primary" text @click="destroyDialog = false">Mejor no</v-btn>
            <v-btn elevation="0" class="pa-4" rounded color="error" @click="destroy">Eliminar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-form>
  </v-container>
</template>

<script>
let item_order = 1

export default {
  data() {
    return {
      destroyDialog: false,
      confirmDialog: false,
      validForm: true,
      previewLoading: false,
      saving: false,
      summary: null,
      emptyRule: [v => !!v || 'Necesario'],
      payload: {
        id: null,
        name: null,
        enabled: true,
        items: [{ order: 1, value: null }]
      }
    }
  },

  methods: {
    addChip() {
      item_order++
      this.payload.items.unshift({ value: '', order: item_order })
    },

    removeChip(index) {
      this.payload.items.splice(index, 1)
    },

    validateForm() {
      if (!this.$refs.form.validate()) return

      // Al crear no hay productos que sincronizar: guardar directo.
      if (this.$route.params.id) {
        this.requestPreview()
      } else {
        this.store()
      }
    },

    // Etapa API: calcula el impacto sin guardar y decide si pedir confirmación.
    requestPreview() {
      this.previewLoading = true

      this.$axios
        .post(`/admin/size-collections/${this.$route.params.id}/preview`, {
          items: this.payload.items
        })
        .then((response) => {
          this.summary = response.data.summary

          // Si nada cambia en los productos, no molestamos con el diálogo.
          const s = this.summary
          const nothingToConfirm =
            !s.productos_afectados ||
            (!s.variantes_creadas && !s.variantes_actualizadas &&
             !s.variantes_eliminadas && !s.inconsistencias)

          if (nothingToConfirm) {
            this.update()
          } else {
            this.confirmDialog = true
          }
        })
        .catch((error) => console.log(error))
        .finally(() => { this.previewLoading = false })
    },

    edit() {
      this.$axios
        .get(`/admin/size-collections/${this.$route.params.id}/edit`)
        .then((response) => { this.payload = response.data.item })
    },

    store() {
      this.saving = true
      this.$axios
        .post('/admin/size-collections', this.payload)
        .then((response) => {
          this.$store.commit('OPEN_SNACKBAR', response.data)
          if (response.data.success) this.$router.push('/size-collections')
        })
        .catch((error) => console.log(error))
        .finally(() => { this.saving = false })
    },

    update() {
      this.saving = true
      this.payload['_method'] = 'PUT' // Laravel put workaround

      this.$axios
        .post(`/admin/size-collections/${this.$route.params.id}`, this.payload)
        .then((response) => {
          this.$store.commit('OPEN_SNACKBAR', response.data)
          if (response.data.success) this.$router.push('/size-collections')
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.saving = false
          this.confirmDialog = false
        })
    },

    destroy() {
      const formData = new FormData()
      formData.append('_method', 'DELETE') // Laravel delete workaround

      this.$axios
        .post(`/admin/size-collections/${this.$route.params.id}`, formData)
        .then((response) => {
          this.$store.commit('OPEN_SNACKBAR', response.data)
          if (response.data.success) this.$router.push('/size-collections')
        })
        .catch((error) => console.log(error))
    }
  },

  computed: {
    sortedItems() {
      // Copia para no mutar el arreglo reactivo original al ordenar.
      return [...this.payload.items].sort((a, b) => a.order - b.order)
    }
  },

  mounted() {
    if (this.$route.params.id) this.edit()
  }
}
</script>
